import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AirCarrierEntity } from 'src/store/air-carrier/air-carrier.model';
import { AirCarrierViewModel } from 'src/view-models/air-carrier-view-model';
import { CurrentUser } from '../core/user.service';
import { AirCarrierHttpClient } from './flight-log-api/air-carriers/air-carriers-client.service';

@Injectable({
  providedIn: 'root',
})
export class AirCarrierResolverService implements Resolve<AirCarrierEntity> {
  constructor(
    private _airCarriers: AirCarrierHttpClient,
    private _user: CurrentUser,
    private _router: Router,
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<AirCarrierViewModel> {
    const airCarrierAbbreviation = route.paramMap.get('airCarrierAbbreviation');
    return this._airCarriers
      .getAll({})
      .pipe(map((airCarriers) => airCarriers.results))
      .pipe(
        map(
          (airCarriers) =>
            airCarriers.filter(
              (airCarrier) => airCarrier.abbreviation === airCarrierAbbreviation,
            )[0],
        ),
      )
      .pipe(
        map((airCarrier) => {
          if (airCarrier == null) {
            throw new Error(
              `AirCarrierResolverService: no air carrier found for air carrier code '${airCarrierAbbreviation}'`,
            );
          }
          return airCarrier;
        }),
      );
  }
}
